import Slider from 'react-slick';
import Box from '@mui/material/Box';
import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';
import { RightArrow, LeftArrow } from '@repo/ui/src/components/Carousels/CarouselArrows';
import AuthorCard from './author-card';
import RecipeCard from './recipe-card';
import ViewAllLink from '../../shared/ViewAllLink';

const carouselType = (schema, props) => {
  switch (schema) {
    case 'https://traegergrills.com/data/contentTypes/author.json':
      return <AuthorCard {...props} />;
    case 'https://traegergrills.com/data/contentTypes/learn.json':
      return <LearnCard {...props} />;
    // case 'https://traegergrills.com/data/contentTypes/product.json':
    //   return <ProductCard {...props} />;
    case 'https://traegergrills.com/data/contentTypes/recipe.json':
      return <RecipeCard {...props} className="col-sm-12 col-md-4 mx-auto tw-mb-6" />;
    default:
      return null;
  }
};

const LearnCard = (props) => {
  const { content, link } = props;
  const imgUrl = buildImageSrc(content.articleModules[0].image, 300, 3, 2);
  const linkUrl = buildLinkObj(link);
  return (
    <div className="col-sm col-4 slick-creator-card-container ">
      <a rel={getRel(linkUrl)} className="tw-cursor-pointer" href={linkUrl.href}>
        <LazyLoadImage
          imgComponent={
            <img
              className="tw-block tw-rounded tw-z-[-1] tw-mb-3"
              src={imgUrl}
              alt={content.title}
            />
          }
        />
        <h6 className="text-left mt-3 slick-creator-card-title">{content.title}</h6>
      </a>
    </div>
  );
};

const MiniContentCreator = (props) => {
  const { content, title, description, categoryLink, _testID } = props;
  const settings = {
    infinite: true,
    arrows: true,
    dots: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    nextArrow: <RightArrow arrowSize="30px" />,
    prevArrow: <LeftArrow arrowSize="30px" />,
    responsive: [
      {
        breakpoint: 993,
        settings: {
          slidesToShow: 4,
          infinite: false,
        },
      },
      {
        breakpoint: 577,
        settings: {
          arrows: false,
          slidesToShow: 3,
          infinite: false,
          dots: true,
        },
      },
    ],
  };
  return (
    <Box
      display="flex"
      className="jumbotron rotating-background"
      data-test-id={`mini_content_carousel_${_testID}`}
    >
      <div className="container">
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <h2 className="rob-top-rated-title">{title}</h2>
          <ViewAllLink link={categoryLink} />
        </Box>
        {description && <p>{description}</p>}

        <Slider className="row" {...settings}>
          {content.map((item, index) => {
            return (
              <div key={item.content.title + index}>
                {carouselType(item.content._meta.schema, item)}
              </div>
            );
          })}
        </Slider>
      </div>
    </Box>
  );
};
export default MiniContentCreator;
